import Button from '../UI/Button/Button';
import Input from '../UI/Input/Input';
import styles from './LoginFrom.module.css';
import { useState } from 'react';
import { authService } from '../../services/auth.service';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setAuth } from '../../redux/slices/auth';
import Alert from '../UI/Alert/Alert';
import { toast } from 'react-toastify';

function LoginForm() {
    const [email, setEmail] = useState({ value: '', error: null });
    const [password, setPassword] = useState({ value: '', error: null });
    const [generalError, setGeneralError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation('auth');
    const { t: tValidation } = useTranslation('validation');


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setEmail({ value: email.value, error: null });
        setPassword({ value: password.value, error: null });
        try {
            const response = await authService.login({ email: email.value, password: password.value });
            if (response.user) {
                dispatch(setAuth({ user: response.user }));
                navigate('/crm/ideas');
            }
        } catch (error) {
            const errorEntity = error?.payload?.error;
            if (Array.isArray(errorEntity)) {
                errorEntity?.forEach(errorItem => {
                    if (errorItem.path[0] === 'email') {
                        setEmail({ value: email.value, error: errorItem });
                    }
                    if (errorItem.path[0] === 'password') {
                        setPassword({ value: password.value, error: errorItem });
                    }
                });
            } else if (typeof errorEntity === 'string') {
                const message = tValidation(errorEntity);
                setGeneralError(message);
                toast.error(message);
            } else {
                toast.error(tValidation('something_went_wrong'));
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.formContainer}>
            <img
                src={`${process.env.PUBLIC_URL}/assets/menu-logo-name-only.png`}
                alt="Logo"
                className={styles.logo}
            />
            <form className={styles.form} onSubmit={handleSubmit}>
                {generalError && <Alert type="error">{generalError}</Alert>}
                <Input type="email" placeholder={t('login.email')} value={email.value} onChange={(e) => setEmail({ value: e.target.value, error: email.error })} error={email.error} />
                <Input type="password" placeholder={t('login.password')} value={password.value} onChange={(e) => setPassword({ value: e.target.value, error: password.error })} error={password.error} />
                <Button variant="warning" type="submit" disabled={isLoading}>{t('login.login')}</Button>
            </form>
        </div>
    );
}

export default LoginForm;